import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY, PRIMARY_DARK, GRAY_LIGHT } from '@theme_color';

const useStyles = makeStyles(() => ({
    titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 20,
    },
    titleIcon: {
        fill: PRIMARY,
        width: 64,
        height: 64,
    },
    titleText: {
        color: PRIMARY_DARK,
        '& .primary': {
            fontSize: 20,
            fontWeight: 'bold',
        },
        '& .secondary': {
            fontSize: 14,
            fontWeight: 'normal',
        },
    },
    cardsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        paddingTop: 20,
    },
    card: {
        borderRadius: 8,
        padding: 16,
        border: `1px solid ${GRAY_LIGHT}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    cardLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: PRIMARY_DARK,
    },
    channelLogo: {
        width: 20,
        height: 20,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
    },
    controlLabelRoot: {
        margin: 0,
        gap: 5,
    },
    controlLabel: {
        fontSize: 12,
        color: PRIMARY_DARK,
    },
    checkboxRoot: {
        padding: 0,
    },
    checkboxLabel: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    checkboxIcon: {
        width: 16,
        height: 16,
        borderRadius: 4,
        border: '1px solid #9CA3AF',
        background: 'white',
    },
    loadingWrapper: {
        display: 'grid',
        placeItems: 'center',
        paddingTop: 20,
    },
}));

export default useStyles;
